export enum QuestionType {
  CompanyForm = 'company_form',
  CompanySize = 'company_size',
  CompanyVertical = 'company_vertical',
  SignupFeatures = 'signup_features',
  EInvoicingPreferences = 'e_invoicing_preferences',
}
